import { DOWNLOAD_POI_REPORT } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction, AppNoApiAction, BaseAsyncReducerState } from "../../types";

export interface DownloadPOIReportState extends BaseAsyncReducerState {
    file: Record<string, unknown> | null
}
// Define an initial state value for the app
const initialState: DownloadPOIReportState  = {
    loading: false,
    error: false,
    file: null
}


function DownloadPOIReportReducer(state = initialState, action: AppAction | AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case DOWNLOAD_POI_REPORT.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case DOWNLOAD_POI_REPORT.SUCCESS:
            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false

            }
        case DOWNLOAD_POI_REPORT.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        default:
            return state
        }
}

export default DownloadPOIReportReducer;